import React, { useState } from 'react';
import { Volume2, VolumeX } from 'lucide-react';
import { VSL_YOUTUBE_ID } from '../../data/site';
export function VslPlayer() {
  // Browsers only allow autoplay when muted — start muted, let her unmute.
  const [muted, setMuted] = useState(true);
  const src = `https://www.youtube.com/embed/${VSL_YOUTUBE_ID}` + `?autoplay=1&mute=${muted ? 1 : 0}&rel=0&modestbranding=1&playsinline=1&controls=1`;
  return <div data-id="element-326" data-mp="1h3klj4tgmwvg">
      <div className="relative" data-id="element-327" data-mp="1h3uff3hmlo6f">
        <div className="absolute -inset-2 rounded-[1.5rem] border border-gold/35" aria-hidden="true" data-id="element-328" data-mp="1m3729o8hyv90" />
        <div className="relative aspect-video overflow-hidden rounded-[1.25rem] bg-ink shadow-lift" data-id="element-329" data-mp="1r3bidd5htnyp">
          <iframe key={muted ? 'muted' : 'unmuted'} src={src} title="La Herradura Dorada — mensaje de Careliz Griman" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen className="h-full w-full" data-id="element-330" data-mp="1v2u42b55232l" />
        </div>
      </div>

      <div className="mt-5 flex justify-center" data-id="element-331" data-mp="1ho5ex8ln9b90">
        <button type="button" onClick={() => setMuted(m => !m)} className="inline-flex items-center gap-2 rounded-full border border-gold/40 bg-ivory px-5 py-2.5 text-[11px] font-medium uppercase tracking-[0.16em] text-ink-soft transition-colors duration-200 hover:border-gold hover:text-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold-dark" data-id="element-332" data-mp="1hmatlt6gnh4e">
          {muted ? <>
              <VolumeX className="h-4 w-4 text-gold-dark" aria-hidden="true" data-id="element-333" data-mp="1ve8s7a2jpumb" />
              Activar sonido
            </> : <>
              <Volume2 className="h-4 w-4 text-gold-dark" aria-hidden="true" data-id="element-334" data-mp="k03qknpt1wu5" />
              Silenciar
            </>}
        </button>
      </div>
    </div>;
}